export default __webpack_public_path__ + "9e237e5abd439760ed5fb6a9cf204ce6.jpg";